import { lazy } from "react"
import { Root } from "src/shared/components"
import PermissionRoute from "../permission-route"
import { Navigate } from "react-router-dom"

//  ---- product routes ----
const ProuductsList = lazy(() => import("src/modules/product-catalogs/products/pages/ProuductsList"))
const CreateProduct = lazy(() => import("src/modules/product-catalogs/products/pages/CreateProduct"))
const UpdateProduct = lazy(() => import("src/modules/product-catalogs/products/pages/UpdateProduct"))
//  ----- categor routes ----
const CategoriesList = lazy(() => import("src/modules/product-catalogs/categories/pages/CategoriesList"))
const CreateCategory = lazy(() => import("src/modules/product-catalogs/categories/pages/CreateCategory"))
const UpdateCategory = lazy(() => import("src/modules/product-catalogs/categories/pages/UpdateCategory"))

const productCatalogRoutes = {
  path: "product-catalog",
  element: <Root />,
  children: [
    { index: true, element: <Navigate to="/app/product-catalog/product" /> },
    {
      path: "product",
      element: <Root />,
      children: [
        {
          index: true,
          element: (
            <PermissionRoute permission="product-catalog:product:read">
              <ProuductsList />
            </PermissionRoute>
          )
        },
        {
          path: "create",
          element: (
            <PermissionRoute permission="product-catalog:product:create">
              <CreateProduct />
            </PermissionRoute>
          )
        },
        {
          path: "update/:id",
          element: (
            <PermissionRoute permission="product-catalog:product:update">
              <UpdateProduct />
            </PermissionRoute>
          )
        }
      ]
    },
    {
      path: "category",
      element: <Root />,
      children: [
        {
          index: true,
          element: (
            <PermissionRoute permission="product-catalog:category:read">
              <CategoriesList />
            </PermissionRoute>
          )
        },
        {
          path: "create",
          element: (
            <PermissionRoute permission="product-catalog:category:create">
              <CreateCategory />
            </PermissionRoute>
          )
        },
        {
          path: "update/:id",
          element: (
            <PermissionRoute permission="product-catalog:category:update">
              <UpdateCategory />
            </PermissionRoute>
          )
        }
      ]
    }
  ]
}

export default productCatalogRoutes
